import { render, staticRenderFns } from "./ChooseDatasets.vue?vue&type=template&id=3927dd5d&"
import script from "./ChooseDatasets.vue?vue&type=script&lang=js&"
export * from "./ChooseDatasets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports